export { default } from './DomainProfile'
